module.exports = __webpack_public_path__ + "static/img/img-nav6.bd4aaa57.png";